import React from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../context/AppContext";
import { discountLabel } from "../util/discount";

/** The small "-15%" / "Sale" tag on a dish that has a running discount. */
const DiscountBadge = ({ discount, className = "" }) => {
  const { t } = useTranslation();
  const { currencySymbol } = useAppContext();
  if (!discount) return null;
  return (
    <span
      dir="ltr"
      className={`rounded-full bg-primary text-white text-xs font-bold px-2 py-0.5 whitespace-nowrap ${className}`}
    >
      {discountLabel(discount, currencySymbol, t("Sale"))}
    </span>
  );
};

export default DiscountBadge;
